import { createTheme } from '@mui/material/styles';

const storeTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0F766E',
      light: '#14B8A6',
      dark: '#115E59',
      contrastText: '#F8FAFC',
    },
    secondary: {
      main: '#E76F51',
      light: '#F4A261',
      dark: '#C84A2D',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#475569',
    },
    divider: 'rgba(15, 23, 42, 0.1)',
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Noto Sans TC", "Noto Sans JP", "Noto Sans KR", sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontWeight: 760, letterSpacing: '-0.015em' },
    h4: { fontWeight: 740 },
    h5: { fontWeight: 720 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, textTransform: 'none', letterSpacing: '0.01em' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: 'radial-gradient(circle at 0% 0%, rgba(20, 184, 166, 0.08), transparent 40%), radial-gradient(circle at 100% 0%, rgba(231, 111, 81, 0.08), transparent 35%), #F8FAFC',
        },
        '::selection': {
          backgroundColor: 'rgba(20, 184, 166, 0.28)',
          color: '#0F172A',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingInline: '1rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          border: '1px solid rgba(15, 23, 42, 0.08)',
          boxShadow: '0 12px 30px rgba(15, 23, 42, 0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 16,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(10px)',
          backgroundImage: 'none',
        },
      },
    },
  },
});

export default storeTheme;
